import { Component, Input, OnInit } from '@angular/core';
import { SupportedSeverityLabels } from 'src/app/models/tableColumns/supportedSeverityLabels.enum';

@Component({
  selector: 'app-severity-label',
  templateUrl: './severity-label.component.html',
  styleUrls: ['./severity-label.component.scss'],
})
export class SeverityLabelComponent implements OnInit {
  @Input() public severity: string;
  @Input() public smallSize?: boolean;

  public supportedSeverityLabels = SupportedSeverityLabels;
  public supportedSeverity: SupportedSeverityLabels;

  ngOnInit(): void {
    this._parseReceivedEnumToSupportedOne();
  }

  private _parseReceivedEnumToSupportedOne() {
    const enumEntry = new Map(Object.entries(SupportedSeverityLabels)).get(this.severity) as SupportedSeverityLabels;

    if (!enumEntry) {
      throw new Error(
        `SeverityLabelComponent parseReceivedEnumToSupportedOne: Value ${this.severity} is not supported in the SupportedSeverityLabels`
      );
    }

    this.supportedSeverity = enumEntry;
  }
}
